import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import { type SubscriptionInvoice } from '../modal/payment';

export const getStudentSubscriptionUpcomingInvoices = async (
  studentId: string,
) => {
  const response = await baseAPI.get<Array<SubscriptionInvoice>>(
    `/subscription-invoices/student/${studentId}/upcoming`,
  );
  return response.data;
};

export const useGetStudentSubscriptionUpcomingInvoices = (
  studentId: string,
) => {
  return useQuery({
    queryKey: [KEYS.UPCOMING_SUBSCRIPTION_INVOICES, studentId],
    queryFn: () => getStudentSubscriptionUpcomingInvoices(studentId),
    // staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
